import React from "react";
import { shape, array, string } from "prop-types";
import { useLocale } from "@insightfulscience/smart-react/i18";
import PageMeta from "@insightfulscience/smart-react/PageMeta";

import { file, pageProps as pagePropsType } from "../../utils/propTypes";
import renderBlockByType from "../../utils/renderBlockByType";

const Page = ({ post, pageProps }) => {
	const [t] = useLocale("standard-pages");
	const { siteDomain, prefix, components } = pageProps;
	const {
		metaTitle = "",
		metaDescription = "",
		metaCanonical,
		slug,
		thumbnail,
		contentReference,
	} = post;

	const thumbnailUrl = thumbnail?.fields?.file?.url || "";
	const url = `${siteDomain}/${prefix ? `${prefix}/` : ""}${slug}`;
	return (
		<>
			<PageMeta title={metaTitle} description={metaDescription}>
				<PageMeta.OGP
					title={metaTitle}
					description={metaDescription}
					url={url}
					image={thumbnailUrl || t("META_IMAGE")}
					imageSecureUrl={thumbnailUrl || t("META_IMAGE_SECURE")}
					isImageBaseUrl={!thumbnailUrl}
				/>
				<PageMeta.Twitter
					card={t("META_TWITTER_CARD")}
					site={t("META_TWITTER_SITE")}
					creator={t("META_TWITTER_CREATOR")}
					title={metaTitle}
					description={metaDescription}
					image={thumbnailUrl || t("META_TWITTER_IMAGE")}
					isImageBaseUrl={!thumbnailUrl}
				/>
				<PageMeta.Canonical href={metaCanonical || url} />
			</PageMeta>
			{contentReference.map(renderBlockByType(slug, components, contentReference))}
		</>
	);
};

Page.propTypes = {
	post: shape({
		metaTitle: string,
		metaDescription: string,
		metaCanonical: string,
		slug: string.isRequired,
		thumbnail: file,
		contentReference: array, // eslint-disable-line react/forbid-prop-types
		formId: string,
	}),
	pageProps: pagePropsType,
};

export default Page;
